import React from 'react';
import { LegalDocPage } from './LegalDocPage';

export const CandidatesPrivacyPage: React.FC = () => {
  return (
    <LegalDocPage
      docId="candidates-privacy"
      title="Avis de confidentialité candidats"
      updatedAt="—"
    />
  );
};
